export function createValueAndHalfValue(obj) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key] = {
      value,
      get half() {
        return this.value / 2;
      },
      get inverted() {
        return -this.value;
      },
      get halfInverted() {
        return -this.half;
      },
    };
    return acc;
  }, {});
}
